import { render, staticRenderFns } from "./ProposalImage.vue?vue&type=template&id=013232b8"
import script from "./ProposalImage.vue?vue&type=script&lang=js"
export * from "./ProposalImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports